"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetFilterBySearchValue = exports.useFilterBySearch = void 0;
const react_1 = require("react");
const selectors_1 = require("../../selectors");
const slice_1 = require("../../slice");
const hooks_1 = require("../../../../store/hooks");
const useFilterBySearch = (listKey, options) => {
    var _a;
    const minLength = (_a = options === null || options === void 0 ? void 0 : options.minLength) !== null && _a !== void 0 ? _a : 3;
    const dispatch = (0, hooks_1.useAppDispatch)();
    const searchValue = (0, exports.useGetFilterBySearchValue)(listKey);
    const onChangeSearch = (0, react_1.useCallback)((value) => {
        if (value.length === 0 && searchValue) {
            dispatch(slice_1.eventsProviderActions.updateFilters({
                listKey,
                filters: {
                    searchQuery: undefined,
                    searchQueryFields: undefined,
                },
            }));
        }
        else if (value.length >= minLength) {
            dispatch(slice_1.eventsProviderActions.updateFilters({
                listKey,
                filters: {
                    searchQuery: value || undefined,
                    searchQueryFields: options === null || options === void 0 ? void 0 : options.searchQueryFields,
                },
            }));
        }
    }, [dispatch, listKey, minLength, options === null || options === void 0 ? void 0 : options.searchQueryFields, searchValue]);
    return {
        value: searchValue || '',
        onChangeSearch,
    };
};
exports.useFilterBySearch = useFilterBySearch;
const useGetFilterBySearchValue = (listKey) => {
    const filters = (0, hooks_1.useAppSelector)((state) => (0, selectors_1.getEventListFilters)(state, listKey));
    return filters.searchQuery || '';
};
exports.useGetFilterBySearchValue = useGetFilterBySearchValue;
//# sourceMappingURL=useFilterBySearch.js.map